export const BROADCAST_TRANSLATION = 'translation'
export const BROADCAST_PROPAGATE_SESSION = 'propagate-session'
